module.exports = require('lodash/get');
